document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.js-navbar-toggle').forEach(el => {
    el.addEventListener('click', () => {
      el.closest('.navbar').querySelector('.navbar-collapse').classList.toggle('in');
    });
  });
});